import { z } from 'zod'

import { NoteSchema, ProposalVersionSchema } from '../property.models.ts'
import { ProjectIdSchema, ProjectServiceIdSchema } from '../unique-id.models.ts'
import { ActivityLinkTargets } from './activity-data.models.ts'
import { ActivityTypeAndDataSchema } from './utilities.ts'

export const PreProductionBrandFeedbackSubmittedActivityDetailsSchema =
  ActivityTypeAndDataSchema(
    'pre_production_brand_feedback_submitted',
    z.object({
      projectId: ProjectIdSchema,
      projectServiceId: ProjectServiceIdSchema,
      approved: z.boolean(),
      version: ProposalVersionSchema,
      note: NoteSchema.optional(),
      ...ActivityLinkTargets('project', 'service'),
    })
  )
